import { render } from "./CaseActivityTable.vue?vue&type=template&id=17be87cb&ts=true"
import script from "./CaseActivityTable.vue?vue&type=script&lang=ts"
export * from "./CaseActivityTable.vue?vue&type=script&lang=ts"

import "./CaseActivityTable.vue?vue&type=style&index=0&id=17be87cb&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__